import React from "react";

import type { ErrorPartType } from "./_part-types";
import { ChatBubble } from "./chat-bubble";

export const ErrorPart: React.FC<{ part: ErrorPartType }> = ({ part }) => (
	<ChatBubble variant="error">{part.content}</ChatBubble>
);
